import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Loader2 } from 'lucide-react';

const toggleScopeItem = (arr, item) =>
  arr.includes(item) ? arr.filter(x => x !== item) : [...arr, item];

const PLANS = [
  { value: 'single', label: 'Single Location' },
  { value: 'multi', label: 'Multi Location' },
];
const CYCLES = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Annual' },
];

export function EditCouponDialog({
  open,
  onClose,
  onSubmit,
  editingCoupon,
  editCouponForm,
  setEditCouponForm,
  submitting,
}) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Coupon — {editingCoupon?.code}</DialogTitle>
          <DialogDescription>Update discount, limits, or expiry date.</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label>Discount (%)</Label>
            <Input
              type="number"
              min="1"
              max="100"
              value={editCouponForm.discount_percent}
              onChange={(e) => setEditCouponForm(prev => ({ ...prev, discount_percent: e.target.value }))}
              data-testid="edit-coupon-discount-input"
              required
            />
          </div>
          <div className="space-y-2">
            <Label>Applies to Plans <span className="text-red-500">*</span></Label>
            <div className="flex gap-4">
              {PLANS.map(({ value, label }) => (
                <label key={value} className="flex items-center gap-2 cursor-pointer text-sm">
                  <input
                    type="checkbox"
                    checked={editCouponForm.applicable_plans.includes(value)}
                    onChange={() => setEditCouponForm(prev => ({
                      ...prev,
                      applicable_plans: toggleScopeItem(prev.applicable_plans, value),
                    }))}
                    data-testid={`edit-coupon-plan-${value}`}
                    className="rounded border-slate-300"
                  />
                  {label}
                </label>
              ))}
            </div>
            {editCouponForm.applicable_plans.length === 0 && (
              <p className="text-xs text-red-500">Select at least one plan</p>
            )}
          </div>
          <div className="space-y-2">
            <Label>Applies to Billing Cycles <span className="text-red-500">*</span></Label>
            <div className="flex gap-4">
              {CYCLES.map(({ value, label }) => (
                <label key={value} className="flex items-center gap-2 cursor-pointer text-sm">
                  <input
                    type="checkbox"
                    checked={editCouponForm.applicable_cycles.includes(value)}
                    onChange={() => setEditCouponForm(prev => ({
                      ...prev,
                      applicable_cycles: toggleScopeItem(prev.applicable_cycles, value),
                    }))}
                    data-testid={`edit-coupon-cycle-${value}`}
                    className="rounded border-slate-300"
                  />
                  {label}
                </label>
              ))}
            </div>
            {editCouponForm.applicable_cycles.length === 0 && (
              <p className="text-xs text-red-500">Select at least one billing cycle</p>
            )}
          </div>
          <div className="space-y-2">
            <Label>Max Uses (leave blank for unlimited)</Label>
            <Input
              type="number"
              min="0"
              placeholder="Unlimited"
              value={editCouponForm.max_uses}
              onChange={(e) => setEditCouponForm(prev => ({ ...prev, max_uses: e.target.value }))}
              data-testid="edit-coupon-max-uses-input"
            />
          </div>
          <div className="space-y-2">
            <Label>Expiry Date (optional)</Label>
            <Input
              type="date"
              value={editCouponForm.expires_at}
              onChange={(e) => setEditCouponForm(prev => ({ ...prev, expires_at: e.target.value }))}
              data-testid="edit-coupon-expiry-input"
            />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
            <Button type="submit" disabled={submitting} data-testid="edit-coupon-submit-btn">
              {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Save Changes'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
